import { apiRequest } from "../util/apiUtils";

export const resourceist = async (params) => {
  try {
    const res = await apiRequest("get", `/resource/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const resourceAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `/resource/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const resourceStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `resource/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const resourceDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `resource/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
